import { useState } from 'react';

import { Tool } from 'app/types/tool';
import { useCreateTestMutation, useUploadTestReportMutation } from 'app/services/tools';
import ToolTestForm from './Form';

const CreateToolTest = ({ tool }: { tool: Tool }) => {
  const [ create, toolMeta ] = useCreateTestMutation();
  const [ uploadReport, fileMeta ] = useUploadTestReportMutation();
  const [ meta, setMeta ] = useState({ isSuccess: false, data: {} });

  const onSubmit = async (values: any) => {
    const toolTest = await create({ toolId: tool.Id, ...values }).unwrap();

    if (values.ReportFile && values.ReportFile && toolTest) {

      const fileList = values.ReportFile as any[] | undefined;
      const first = fileList?.[0];

      if (toolTest?.Id && first) {
        await uploadReport({ testId: toolTest.Id, file: first.originFileObj }).unwrap();
      }
    }

    setMeta({ isSuccess: true, data: { Id: toolTest.Id } });
  };

  return <ToolTestForm
    handleSubmit={onSubmit}
    meta={{
      isSuccess: meta.isSuccess,
      isLoading: toolMeta.isLoading || fileMeta.isLoading,
      isError: toolMeta.isError || fileMeta.isError,
      data: meta.data
    }}
  />;
};

export default CreateToolTest;